// Single-line text attribute.

import React from 'react';
import TextField from '@decisiv/ui-components/lib/components/TextField';

import { fieldPropTypes } from './fieldPropTypes';

const TextInput = ({
  descriptor,
  label,
  value,
  warningMessage = '',
  readOnly = true,
  onChange,
  onBlur,
}) => (
  <TextField
    name={descriptor.name}
    label={label}
    required={descriptor.required}
    helpMessage={descriptor.description}
    warningMessage={warningMessage}
    disabled={readOnly}
    value={value ?? ''}
    onChange={(e) => onChange(descriptor.name, e.target.value)}
    onBlur={() => onBlur?.(descriptor.name)}
  />
);

TextInput.propTypes = fieldPropTypes;

export default TextInput;
